

export class TokenPrintModel {
    employeeCode: string;
    employeeName: string;
    freebieCategory: string;
    tokenDate: string;
    consumedTokens: number;
    availableTokens: number;
    tokenStartsAt: string; // time period in which the token starts
    tokenExpiresAt: string; // time period in which the token expires
    price: number;

    /**
     * 
     * @param employeeCode 
     * @param employeeName 
     * @param freebieCategory 
     * @param tokenDate 
     * @param consumedTokens 
     * @param availableTokens 
     * @param tokenStartsAt 
     * @param tokenExpiresAt 
     * @param price
     */
    constructor(employeeCode: string,employeeName: string,freebieCategory: string,tokenDate: string,consumedTokens: number,availableTokens: number,tokenStartsAt: string,
        tokenExpiresAt: string, price: number) {
        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.freebieCategory = freebieCategory;
        this.tokenDate = tokenDate;
        this.consumedTokens = consumedTokens;
        this.availableTokens = availableTokens;
        this.tokenStartsAt = tokenStartsAt;
        this.tokenExpiresAt = tokenExpiresAt;
        this.price = price;
    }
}